import {
  GET_ADDPERMIT_WITHOUTSESSION_TEXT,
  SET_ADDPERMIT_WITHOUTSESSION_TEXT,
  SET_ADDPERMIT_TEXT,
  SET_ADDPERMIT_SELECT_DATE,
} from "./action";
const defaultState = {
  __htmlWithSession: "",
  __htmlWithoutSession: "",
  setpermitText:[]
};

export default function registerState(state = defaultState, action) {
  switch (action.type) {
    case GET_ADDPERMIT_WITHOUTSESSION_TEXT:
      return state;
    case SET_ADDPERMIT_WITHOUTSESSION_TEXT:
      return { ...state, ["__htmlWithoutSession"]: action.payload };
      case SET_ADDPERMIT_SELECT_DATE:
        return {
          ...state,
          setpermitText: action.payload,
        };
    case SET_ADDPERMIT_TEXT:
      return { ...state, ["__htmlWithSession"]: action.payload.text };
    default:
      return state;
  }
}
